export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-accent-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/20 text-white text-sm font-medium mb-5">
              <i className="ri-smartphone-line"></i>
              <span>移动端阅读体验</span>
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white mb-4">
              随时随地，下拉式畅读漫画
            </h2>
            <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-lg mx-auto lg:mx-0">
              YY漫画网支持手机端完美适配，下拉式阅读体验流畅自然。
              无论你在通勤路上还是睡前时光，打开浏览器即可免费看漫画，
              无需下载安装，即点即看，收藏追更同步进行。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-accent-600 font-semibold rounded-full hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-play-circle-line"></i>
                立即开始阅读
              </a>
              <span className="text-white/60 text-sm flex items-center gap-1">
                <i className="ri-check-line"></i>
                无需安装 · 即开即看
              </span>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="relative w-56 md:w-64">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20manga%20comic%20reading%20interface%20with%20warm%20coral%20and%20cream%20colors%2C%20webtoon%20style%20vertical%20scrolling%20layout%2C%20clean%20modern%20UI%2C%20soft%20lighting%2C%20minimalist%20device%20presentation%2C%20isolated%20on%20transparent%20background&width=600&height=1000&seq=app-mobile-manga&orientation=portrait"
                alt="YY漫画网 移动端阅读 下拉式漫画 手机在线看漫画"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}